"use client";

import { usePathname } from "next/navigation";
import { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const pathname = usePathname();
  const [locale, setLocale] = useState("en-IQ");
  const [lang, setLang] = useState("en");

  useEffect(() => {
    // Get locale from pathname
    if (pathname?.startsWith("/ar-IQ")) {
      setLocale("ar-IQ");
      setLang("ar");
    } else if (pathname?.startsWith("/en-IQ")) {
      setLocale("en-IQ");
      setLang("en");
    } else {
      // Try to get from cookie
      const cookieLocale = document.cookie
        .split("; ")
        .find((row) => row.startsWith("NEXT_LOCALE="))
        ?.split("=")[1];

      if (cookieLocale) {
        setLocale(cookieLocale);
        setLang(cookieLocale.startsWith("ar") ? "ar" : "en");
      }
    }
  }, [pathname]);

  return (
    <LanguageContext.Provider value={{ locale, lang, setLocale, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
}
